import { useEffect } from 'react';
import { useDispatch, useSelector } from 'core/common/hooks';
import { getQueryParams } from 'core/common/utils/getQueryParams';
import { EmailFlowAttributes } from 'core/flow/entities/EmailFlowAttributes';
import { useEmailFlow } from 'core/flow/hooks';
import { fetchOrderRequest } from '../store/actions';
import { getOrderId } from '../store/selectors';

type UseGetOrderParams = {
  emailFlowAttributes: EmailFlowAttributes['emailFlowAttributes'];
};

export const useGetOrder = ({ emailFlowAttributes }: UseGetOrderParams) => {
  const dispatch = useDispatch();
  const orderId = useSelector(getOrderId);
  const { getEmailFlow } = useEmailFlow();

  const params = getQueryParams<{ order_id: string; user_id: string; email?: string }>();
  const { order_id, user_id } = params;
  useEffect(() => {
    if (!order_id || !user_id) {
      return;
    }

    const emailFlow = getEmailFlow(emailFlowAttributes);

    dispatch(fetchOrderRequest(emailFlow, params));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  return {
    orderId,
  };
};
